module.exports = __webpack_public_path__ + "img/shop.eedfb290.png";